import { useNavigate, useLocation } from "react-router-dom";
import { IoCreateOutline, IoEyeOutline } from "react-icons/io5";
import "./list.css";

const ActionCol = ({ row, uriBasePath }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isWorkOrderSection = location.pathname.includes("/work-order");
  const rawBase = isWorkOrderSection
    ? "/work-order/customers"
    : uriBasePath || "";
  const basePath = rawBase.startsWith("/") ? rawBase : `/${rawBase}`;

  return (
    <span className="list-actions">
      <button
        type="button"
        className="list-icon-btn list-icon-edit"
        title="Edit"
        onClick={() => navigate(`${basePath}/${row.id}/edit`)}
      >
        <IoCreateOutline size={16} />
      </button>
      <button
        type="button"
        className="list-icon-btn list-icon-view"
        title="View"
        onClick={() => navigate(`${basePath}/${row.id}`)}
      >
        <IoEyeOutline size={16} />
      </button>
    </span>
  );
};

export default ActionCol;
